import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Work\\Completed Projects\\Next\\Bohesto\\Bohesto\\Bohesto\\components\\layout\\Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\Work\\Completed Projects\\Next\\Bohesto\\Bohesto\\Bohesto\\node_modules\\next\\dist\\client\\app-dir\\link.js");
